import React, { useContext, useMemo } from 'react';

import { ApiContext } from '_lib/api/apiContext';
import { PoolBrainContactCustomerSchema, PoolBrainCustomerLocationDTO } from '_lib/api/apiTypes.shim';

import { ErrorAlert } from '_lib/components/Alert/Alert';
import { Button } from '_lib/components/Button/Button';
import { CardBox } from '_lib/featureComponents/CardBox/CardBox';

import { useMissingCustomerLocationInfoDialog } from '../../../hooks/MissingCustomerLocationInfoDialogHook';
import { CustomerLocationDetail } from '../../CustomerLocationPane/CustomerLocationDetail/CustomerLocationDetail';

type CustomerLocationCardProps = {
  customerLocation: PoolBrainCustomerLocationDTO;
  companyId: string;
  handleSetCustomerLocation: (customerLocation: PoolBrainCustomerLocationDTO) => void;
};

export const CustomerLocationCard = (props: CustomerLocationCardProps) => {
  const { customerLocation, handleSetCustomerLocation, companyId } = props;

  const missingCustomerLocationInfoDialog = useMissingCustomerLocationInfoDialog();

  const api = useContext(ApiContext);
  const poolBrainApi = useMemo(() => api.poolBrain(companyId), [api, companyId]);

  const parsedCustomer = PoolBrainContactCustomerSchema.safeParse(customerLocation.customer);

  return (
    <CardBox>
      {!parsedCustomer.success && (
        <ErrorAlert
          variant='filled'
          action={
            <Button
              onClick={async () => {
                const result = await missingCustomerLocationInfoDialog.show({
                  customerLocation,
                  poolBrainCustomerResource: poolBrainApi.customers,
                  issues: parsedCustomer.error.issues
                });
                if (result?.action === 'CONFIRM') {
                  handleSetCustomerLocation({ ...customerLocation, customer: result.value.customerContact });
                }
              }}
              text='Fix'
              color='cancel'
              variant='contained'
              size='small'
              sx={(theme) => ({ color: theme.palette.error.main })}
            />
          }>
          Invalid Customer
        </ErrorAlert>
      )}
      <CustomerLocationDetail
        customerLocation={customerLocation}
        headerVariant='body1Bold'
        readonly
        sx={{ padding: 0.5 }}
      />
      {missingCustomerLocationInfoDialog.element}
    </CardBox>
  );
};
